export default "__VITE_ASSET__COpa118e__"